import { cliSimpleGit } from '../cli-simple-git.js';

/** Add a worktree for an existing local branch (no `-b`). */
export async function gitWorktreeAddExistingBranch(
  mainRepoPath: string,
  worktreePath: string,
  branch: string,
): Promise<void> {
  const mainGit = cliSimpleGit(mainRepoPath);
  await mainGit.raw(['worktree', 'add', worktreePath, branch]);
}
